import api from './api.js';

export const superAdminRolesAPI = {
  // Get all roles
  async getRoles(params = {}) {
    const response = await api.get('/api/roles', { params });
    return response.data;
  },

  // Get role statistics
  async getRoleStats() {
    const response = await api.get('/api/super-admin-roles/stats');
    return response.data;
  },

  // Get available permissions
  async getAvailablePermissions() {
    const response = await api.get('/api/roles/permissions');
    return response.data;
  },

  // Get single role by ID
  async getRole(roleId) {
    const response = await api.get(`/api/roles/${roleId}`);
    return response.data;
  },

  // Create new role
  async createRole(roleData) {
    const response = await api.post('/api/roles', roleData);
    return response.data;
  },

  // Update role
  async updateRole(roleId, roleData) {
    const response = await api.put(`/api/roles/${roleId}`, roleData);
    return response.data;
  },

  // Delete role
  async deleteRole(roleId) {
    const response = await api.delete(`/api/roles/${roleId}`);
    return response.data;
  },

  // Assign role to sub-account
  async assignRoleToSubAccount(subAccountId, roleId) {
    const response = await api.put(`/api/users/${subAccountId}`, {
      assignedRoleId: roleId,
      assignedRoleModel: 'SuperAdminRole' // This is correct for superAdminRolesAPI
    });
    return response.data;
  },

  // Remove role from sub-account
  async removeRoleFromSubAccount(subAccountId) {
    const response = await api.put(`/api/users/${subAccountId}`, {
      assignedRoleId: null,
      assignedRoleModel: null
    });
    return response.data;
  },

  // Submit approval request for role creation
  async submitApprovalRequest(approvalData) {
    const response = await api.post('/api/roles', approvalData);
    return response.data;
  },

  // Get pending role approval requests
  async getPendingRoleApprovals(params = {}) {
    const response = await api.get('/api/roles/approval-requests/pending', { params });
    return response.data;
  },

  // Get role approval history
  async getRoleApprovalHistory(params = {}) {
    const response = await api.get('/api/roles/approval-requests/history', { params });
    return response.data;
  },

  // Approve role creation request
  async approveRoleRequest(requestId, approvalData = {}) {
    const response = await api.put(`/api/roles/approval-requests/${requestId}/approve`, approvalData);
    return response.data;
  },

  // Reject role creation request
  async rejectRoleRequest(requestId, rejectionData = {}) {
    const response = await api.put(`/api/roles/approval-requests/${requestId}/reject`, rejectionData);
    return response.data;
  }
}; 